import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { GeneralUserVerificationError } from '../../google-authentication/errors/GeneralUserVerificationError';
import { getMetricsCounter } from '../../metrics/Metrics';
import { OAuthToVerifyEndpoint } from '../../oauth/OAuthMapping';
import { OAuthActionTypes } from './action-types';
export const oAuthAuthStarted = provider => dispatch => {
  getMetricsCounter(`${provider}-auth-started`).increment();
  return dispatch({
    type: OAuthActionTypes.AuthStarted,
    provider
  });
};
export const oAuthAuthSucceeded = (authResponse, provider) => dispatch => {
  getMetricsCounter(`${provider}-auth-succeeded`).increment();
  return dispatch({
    type: OAuthActionTypes.AuthSucceeded,
    payload: authResponse,
    provider
  });
};
export const oAuthAuthFailed = (err, provider) => dispatch => {
  getMetricsCounter(`${provider}-auth-failed`).increment();
  return dispatch({
    type: OAuthActionTypes.AuthFailed,
    payload: err,
    provider
  });
};
export const oAuthVerificationStarted = provider => dispatch => {
  getMetricsCounter(`${provider}-auth-verification-started`).increment();
  return dispatch({
    type: OAuthActionTypes.VerificationStarted,
    provider
  });
};
export const oAuthVerificationSucceeded = (response, provider) => dispatch => {
  getMetricsCounter(`${provider}-auth-verification-succeeded`).increment();
  return dispatch({
    type: OAuthActionTypes.VerificationSucceeded,
    payload: response,
    provider
  });
};
export const oAuthVerificationFailed = (err, provider) => dispatch => {
  getMetricsCounter(`${provider}-auth-verification-failed`).increment();
  return dispatch({
    type: OAuthActionTypes.VerificationFailed,
    payload: err,
    provider
  });
};
export const OAuthExistingUserErrorMessage = 'user already exists';
export const verifyOAuthVerificationPayload = (token, provider, isTokenFromGooglePrompt = false) => dispatch => {
  dispatch(oAuthVerificationStarted(provider));
  return noAuthApiClient // Post ACQ131: remove ! from below
  .post(OAuthToVerifyEndpoint[provider], {
    data: token
  }).then(response => {
    if ('message' in response) {
      const {
        message = ''
      } = response;
      const hasErrorMessage = message.includes(OAuthExistingUserErrorMessage);

      if (hasErrorMessage) {
        dispatch(oAuthVerificationFailed({
          status: OAuthExistingUserErrorMessage
        }, provider));
      }
    } else {
      dispatch(oAuthVerificationSucceeded(response, provider));
    }

    return response;
  }).catch(error => {
    if (!isTokenFromGooglePrompt) {
      dispatch(oAuthVerificationFailed(error, provider));
    }

    throw new GeneralUserVerificationError();
  });
};